import {createRouter, createWebHistory} from "vue-router"

const router = createRouter({
	//history: 路由模式 hash路径是带‘#’号和history
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			redirect: "/home"
		},
		{
			path: "/home",
			name: "home",
			component: () => import("../views/home/HomeView.vue")
		},
		{
			path: "/about",
			name: "about",
			component: () => import("../views/about/AboutView.vue"),
		},
		{
			path: "/center/lab",
			name: "centerLab",
			component: () => import("../views/center-lab/CenterLabView.vue"),
		},
		{
			path: "/center/lab/intro",
			name: "centerLabIntro",
			component: () => import("../views/center-lab/CenterLabIntroView.vue"),
		},
		{
			path: "/center/lab/detail/:name/:id",
			name: "centerLabDetail",
			component: () => import("../views/center-lab/CenterLabDetailView.vue"),
			props: route => ({
				name: route.params.name,
				id: route.params.id
			})
		},
		{
			path: "/center/lab/adv",
			name: "centerLabAdv",
			component: () => import("../views/center-lab/CenterLabAdvantageView.vue"),
		},
		{
			path: "/topic",
			name: "topic",
			component: () => import("../views/topic/TopicView.vue"),
		},
		{
			path: "/topicServiceList/:name/",
			name: "topicServiceList",
			component: () => import("../views/topic/TopicArticlesListView.vue"),
			props: route => ({
				name: route.params.name,
				tab: route.params.tab,
			})
		},
		{
			path: "/topic/articles/detail/:name/:categories?/:id",
			name: "topicArticlesDetailView",
			component: () => import("../views/topic/TopicArticlesDetailView.vue"),
			props: route => ({
				name: route.params.name,
				categories: route.params.categories || null, // 如果没有 categories，则赋值为 null
				id: route.params.id
			})
		},
		{
			path: "/model-guide",
			name: "modelGuide",
			component: () => import("../views/platform/PlatformModelGuideView.vue"),
			meta: {
				isShowHeader: false,
			}
		},
		{
			path: "/platform/service",
			name: "platformService",
			component: () => import("../views/platform/PlatformServiceView.vue"),
		},
		{
			path: "/platformServiceList/:name",
			name: "platformServiceList",
			component: () => import("../views/platform/PlatformArticlesListView.vue"),
		},
		{
			path: "/platform/articles/detail/:name/:categories?/:id",
			name: "platformArticlesDetailView",
			component: () => import("../views/platform/PlatformArticlesDetailView.vue"),
			props: route => ({
				name: route.params.name,
				categories: route.params.categories || null, // 如果没有 categories，则赋值为 null
				id: route.params.id
			})
		},
		{
			path: "/platform/intro/:platform",
			name: "platformIntro",
			component: () => import("../views/platform/PlatformIntroView.vue"),
		},
		{
			path: "/news",
			name: "news",
			component: () => import("../views/news/NewsView.vue"),
		},
		{
			path: "/ai-consult",
			name: "aiConsult",
			component: () => import("../views/ai-consult/AiConsultView.vue"),
		},
		{
			path: "/ai-consult/privacy",
			name: "aiConsultPrivacy",
			component: () => import("../views/ai-consult/AiPrivacyNotice.vue"),
		},
		{
			path: "/search/:word",
			name: "search",
			component: () => import("../views/search/SearchView.vue"),
		},
		{
			path: "/news/detail/:id",
			name: "newsDetail",
			component: () => import("../views/news/NewsDetailView.vue"),
		},
		{
			path: "/contact",
			name: "contact",
			component: () => import("../views/contact/ContactView.vue"),
			meta: {
				isShowHeader: true,
			}
		},
		{
			path: "/videos",
			name: "videos",
			component: () => import("../views/video/VideoListView.vue"),
		},
		{
			path: "/video/:id",
			name: "video",
			component: () => import("../views/video/VideoView.vue"),
		},
		{
			path: "/test",
			name: "test",
			component: () => import("../views/test.vue"),
		},
	],
})

export default router
